import React from 'react';
import useClickOutside from 'Components/GMS/CustomHooks/useClickOutside';
import { DELETE } from 'Pages/GMS/ISR/ISRConstants';
import { OverFlowIcon } from 'assests/GmsIcons';
import { Link } from 'react-router-dom';

type TDeleteDataModelProps = {
    onContextMenuOptionClick: () => void;
}

const DeleteDataModel = ({ onContextMenuOptionClick }: TDeleteDataModelProps) => {
    const { showMenu, ref, handleClick } = useClickOutside();

    const handleDeleteClick = () => {
        onContextMenuOptionClick();
    };

    return (
        <div ref={ref} className='tw-relative tw-bg-white  tw-pe-2'>        
            <div className='tw-cursor-pointer tw-py-2 tw-px-3 tw-rounded-lg hover:tw-bg-shades-of-grey-20' onClick={handleClick}>
                <OverFlowIcon />
            </div>
            {showMenu ? (
                <div className={`tw-origin-top-left tw-bottom-1 tw-right-0 tw-absolute tw-w-40 tw-mx-3 tw-rounded-[4px] tw-z-50 tw-bg-white tw-ring-1 tw-ring-[#EBECF0]`}>
                    <div className={`tw-py-1`} role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                        <Link to="#" onClick={(e) => {e.stopPropagation(); handleDeleteClick(); handleClick();}} className={`tw-block tw-px-4 tw-py-1 tw-text-sm tw-text-[#BF2600] hover:tw-bg-[#F0F3FE] hover:tw-text-[#BF2600]`} role="menuitem">{DELETE}</Link>
                    </div>
                </div>                        
            ) : null}
        </div> 
    );
}

export default DeleteDataModel